/* eslint-disable import/no-anonymous-default-export */
import { FormationList } from './list/FormationList';
import { FormationSummary } from '@wwf/sdk';

export default {
    list: FormationList,
    recordRepresentation: (record: FormationSummary) =>
        record.url ?? `${record.id}`,
};
